// SymptomNeckPain.jsx（首に特化）
import DocPageLayout from './DocPageLayout.js';
import {
  WarningAmberOutlined,
  HealthAndSafetyOutlined,
  EmojiObjectsOutlined
} from '@mui/icons-material';
import './DocPage.css';

const heroImage = '/img/facial-care.webp'; // 適宜差し替え

const symptomSections = [
  {
    icon: WarningAmberOutlined,
    title: '首が痛くなる原因は？',
    description: [
      '前傾姿勢や長時間のスマホ・PC作業で首周囲の筋肉が緊張し、血行不良が起きるのが主因です。ストレスや疲労、睡眠不足や枕の高さ不適合など生活要因も痛みを助長します。'
    ]
  },
  {
    icon: HealthAndSafetyOutlined,
    title: 'スマホ首（ストレートネック）とは？',
    description: [
      '頭が前に出る姿勢が続くことで首後面の筋が過緊張し、頸椎のカーブが崩れて痛みや不調を誘発します。頭痛や吐きけを伴うこともあるため、画面位置調整やこまめな休憩・ストレッチが有効です。'
    ]
  },
  {
    icon: WarningAmberOutlined,
    title: '首の痛みにつながる代表的な疾患',
    steps: [
      '寝違え：睡眠中の不自然姿勢や枕不適合で筋・靭帯が緊張し、朝に可動域が制限され痛む。',
      '頸椎捻挫（むち打ち）：急な外力で頸部の筋・靭帯が損傷。首の痛みや頭痛、めまい・吐きけを伴うことがある。',
      'ストレートネック：前かがみ姿勢の習慣で頸椎カーブが減少し、首のこわばりや痛みを起こす。',
      '頸椎ヘルニア：変性した椎間板が神経を圧迫し、首の痛みに加え、場合により手指のしびれ・筋力低下を伴うことがある。'
    ]
  },
  {
    icon: EmojiObjectsOutlined,
    title: '首の施術の方法とは？',
    steps: [
      '首の痛みを生む筋・筋膜や頸椎周囲の緊張ポイントを、問診・触診で特定します。',
      '全身バランスを整える施術で、首の筋・筋膜の柔軟性と頸椎の可動域を回復させます。',
      '再発予防として、作業姿勢・画面位置・枕の高さ・セルフストレッチや休憩習慣を指導します。'
    ]
  },
  {
    icon: WarningAmberOutlined,
    title: 'このまま首の痛みを放っておくと',
    description: [
      '慢性化して可動域が狭くなる、頭痛・吐きけが増える、日常の動作で強い張りや痛みが出るなど支障が拡大します。',
      '早期に原因へアプローチし、姿勢・生活環境の見直しと併せて整えていくことが重要です。'
    ]
  }
];

const SymptomNeckPain = () => (
  <DocPageLayout
    currentRoute="/symptoms/neck-pain"
    pageTitle="首"
    heroImage={heroImage}
    heroImageAlt="首の痛みに悩む方"
    heroHighlight="首が痛いのは、なぜ？"
    heroDescription={[
      '多くの首の痛みは、姿勢不良や長時間のスマホ・PC作業による筋緊張と血行不良が土台。生活要因（睡眠・枕の高さ）も影響します。',
      '頭痛や吐きけを伴う場合も。原因を特定し、首だけでなく全身バランスから整えます。'
    ]}
  >
    {symptomSections.map(({ icon: Icon, title, description, steps }) => (
      <article key={title} className="doc-section">
        <h3 className="doc-section__title">
          <Icon className="doc-section__icon" />
          {title}
        </h3>
        <div className="doc-section__body">
          {description && description.map((text) => <p key={text}>{text}</p>)}
          {steps && (
            <ol className="doc-ordered-list">
              {steps.map((step) => (
                <li key={step}>{step}</li>
              ))}
            </ol>
          )}
        </div>
      </article>
    ))}
    <p className="doc-final-note">当院の、首の痛み施術を受けて頂くことをお勧めします。</p>
    <div className="doc-page__cta">
      <a
        className="doc-reservation-button"
        href="https://book.squareup.com/appointments/hqjlguwjlxeenh/location/MH09XMWCMM5H9/services"
        target="_blank"
        rel="noopener noreferrer"
      >
        ご予約はこちら
      </a>
    </div>
  </DocPageLayout>
);

export default SymptomNeckPain;
